import React from 'react';
import { isChecked, valueEmpty, isSelected } from '../uiFunctions/uiHelpers';

export class InputRow extends React.Component {
	resetSelectElement(id) {
		let select = document.getElementById(id);
		select.selectedIndex = 0;  // 0 first option, or -1 for no option
		var event = new Event('change', { bubbles: true });
    	select.dispatchEvent(event);
	}
	render() {
		let label = this.props.label;
		let placeholder = this.props.placeholder;
		let type = this.props.type;
		let value = this.props.value;
		let property = this.props.property;
		let disabled = this.props.disabled;
		let options = this.props.options;
		let hideSelectOption = this.props.hideSelectOption;
		let description = this.props.description;
		let rows = this.props.rows;
		let id = this.props.id;
		let onChange = this.props.onChange;
		let data = this.props.data;
		let accept = this.props.accept;
	
		return(
			<div className="input-row">
				{(label) && (
					<label htmlFor={property}>{label}</label>
				)}
				
				{(type === "checkbox" && !disabled) && (
					<div>
						<input type={type} name={property} defaultChecked={isChecked(value)} placeholder={label || placeholder} id={id} onClick={onChange} customdata={data} />
						<p>{description}</p>
					</div>
				)}
				{(type === "checkbox" && disabled) && (
					<div>
						<input type={type} name={property} defaultChecked={isChecked(value)} placeholder={label || placeholder} id={id} disabled />
						<p>{description}</p>
					</div>
				)}

				{(type === "date" || type === "number" || type === "color" || type==="datetime-local") && (
					<div>
						<input type={type} name={property} defaultValue={valueEmpty(value)} id={id} onChange={onChange} customdata={data} />
						<p>{description}</p>
					</div>
				)}

				{(type === "text" && !disabled) && (
					<div>
						<input
							type={type}
							name={property}
							defaultValue={valueEmpty(value)}
							placeholder={label || placeholder}
							id={id}
							onChange={onChange}
							customdata={data}
						/>
						<p>{description}</p>
					</div>
				)}
				{(type === "text" && disabled) && (
					<div>
						<input
							type={type}
							name={property}
							defaultValue={valueEmpty(value)}
							placeholder={label || placeholder}
							id={id}
							disabled
						/>
						<p>{description}</p>
					</div>
				)}

				{(type === "textarea") && (
					<div>
						<textarea
							name={property}
							defaultValue={valueEmpty(value)}
							placeholder={label || placeholder}
							rows={rows}
							id={id}
							onChange={onChange}
							customdata={data}
						></textarea>
						<p>{description}</p>
					</div>
				)}

				{(type === "select" && !disabled) && (
					<div>
						<div className="select">
							<select id={id} name={property} onChange={onChange} customdata={data}>
								{(hideSelectOption !== "true") && (
									<option defaultValue="NULL" selected disabled>Select...</option>
								)}
								{options.map((option, index) => 
									<option key={index} value={option.value} selected={isSelected(option.value, value)}>{option.name}</option>
								)}
							</select>
							<div className="select_arrow"></div>
							<div className="select_reset" onClick={() => this.resetSelectElement(id)}>X</div>
						</div>
						<p>{description}</p>
					</div>
				)}
				{(type === "select" && disabled) && (
					<div>
						<div className="select">
							<select id={id} name={property} disabled>
								<option defaultValue disabled>Select...</option>
								{options.map(option => 
									<option key={option.value} value={option.value} selected={isSelected(option.value, value)}>{option.name}</option>
								)}
							</select>
						</div>
						<p>{description}</p>
					</div>
				)}
				{(type === "file") && (
					<div>
						<input type="file" name={property} id={id} accept={accept} onChange={onChange} />
						<p>{description}</p>
					</div>
				)}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/InputRow.js